import React, { useState } from 'react';
import Example from './Example';
import ExampleSigong from './Examplesigong';

const SigongInfo = (props) => {
  const { u_sigong, setSigong, onChange, u_company_num, u_company_name, u_bank, u_holder,u_email,u_account,onCheckedElement,
          u_dam,u_dam_num,u_brand,bChecked,checkHandler,brandChange,tvTech,postModal,u_sa_address_1,u_sa_address_2,u_sa_address_3} = props;
   
 
      

  const padRight = {
      paddingRight :'40px',
      color:'#0B4FA0',
      textAlign:'left'
  }
  console.log('u_sigong', u_sigong);

  return (
    <>
      <div className="id">
        <div className="id">
            <div className="input">담당자명  
              <input className='ml-2' checked={bChecked} onChange={(e) => checkHandler(e)} type="checkbox" /> 
              <span className='text-danger ml-2 fs-small'>*대표자와 동일</span> 
            </div>
            <div>
                <input name="u_dam"  placeholder="" className="userId" type="text" value={u_dam} onChange={onChange} />
            </div>
        </div>
        <div className="id">
            <div className="input">담당자 연락처</div>
            <div>
              <input name="u_dam_num" className="userId" type="text" value={u_dam_num} onChange={onChange} />
            </div>
        </div>
        
        <div className="id">
            <div className="input">사업자명</div>
            <div>
                <input name="u_company_name"  placeholder="사업자명을 입력해주세요." className="userId" type="text" value={u_company_name} onChange={onChange} />
            </div>
        </div>
        <div className="id">
            <div className="input">사업자등록번호</div>
            <div>
                <input name="u_company_num"  placeholder="사업자등록번호를 입력해주세요." className="userId" type="text" value={u_company_num} onChange={onChange} />
            </div>
        </div>
        <div className="input">사업장 우편번호</div>
        <div className="id">
          <input
            name="u_sa_address_1"
            className="userId"
            type="text"
            value={u_sa_address_1}
            readOnly
            style={padRight}
            onClick={postModal}
            placeholder={"클릭해주세요"}
          />
          {/* <ExampleSigong
            buttonLabel="조회"
            u_sigong={u_sigong}
            setSigong={setSigong}
          /> */}
        </div>
        <div className="id">
            <div className="input">사업장 주소</div>
            <div>
                <input name="u_sa_address_2"  readOnly placeholder="사업자 주소." className="userId" type="text" value={u_sa_address_2} onChange={onChange} />
            </div>
        </div>
        <div className="id">
            <div className="input">사업장 상세주소</div>
            <div>
                <input name="u_sa_address_3"  placeholder="사업자상 상세주소." className="userId" type="text" value={u_sa_address_3} onChange={onChange} />
            </div>
        </div>
        <div className="id">
            <div className="input">입금계좌_은행</div>
            <div>
                <input name="u_bank"  placeholder="입금계좌_은행을 입력해주세요." className="userId" type="text" value={u_bank} onChange={onChange} />
            </div>
        </div>
        <div className="id">
            <div className="input">계좌</div>
            <div>
                <input name="u_account"  placeholder="계좌번호를 입력해주세요." className="userId" type="text" value={u_account} onChange={onChange} />
            </div>
        </div>
        <div className="id">
            <div className="input">예금주  
            <span className='text-danger ml-2 fs-small'>*사업자명 또는 대표자명</span> 
            </div>
            <div>
                <input name="u_holder"  placeholder="예금주를 입력해주세요." className="userId" type="text" value={u_holder} onChange={onChange} />
            </div>
        </div>

        <div className="text-left">
            <div className="input">취급 썬팅브랜드</div>
            <input className="mx-3 mt-4" type="checkbox" onChange={e => {
              onCheckedElement(e.target.checked,e.target.value);
            }} name="u_brand" id="madicoaby" value="마디코 아비스"  />
            <label for="madicoaby">마디코 아비스</label><br></br>
            <input className="mx-3" type="checkbox" onChange={e => {
              onCheckedElement(e.target.checked,e.target.value);}} name="u_brand" id="hyper" value="썬가드 하이퍼" />
            <label for="hyper">썬가드 하이퍼</label><br></br>
            <input className="mx-3" type="checkbox" onChange={e => {
              onCheckedElement(e.target.checked,e.target.value);}} name="u_brand" id="ruma" value="루마 버텍스" />
            <label for="ruma">루마 버텍스</label>
        </div>

        <div className='text-left'>
          <div className='input'>티비테크 제휴점 확인</div>
          <input className="mx-3" type="radio" onChange={onChange} id="techY" name="u_tv_tech" value="Y" checked={tvTech} />
          <label for="techY">YES</label>
          <input className="mx-3" type="radio" onChange={onChange} id="techN" name="u_tv_tech" value="N" checked={!tvTech} />
          <label for="techN">NO</label>
        </div>

        <div className="id">
            <div className="input">이메일  
            </div>
            <div>
                <input name="u_email"  placeholder="이메일을 입력해주세요." className="userId" type="text" value={u_email} onChange={onChange} />
            </div>
        </div>

      </div>
    </>
  );
};

export default SigongInfo;
